import {
  BarChart3,
  Calendar,
  Home,
  Image as ImageIcon,
  Layers,
  Settings,
  Star,
  User,
  Users,
  Users2,
} from 'lucide-react';

import { ROUTES } from '@/shared/config/routes';

export type NavItem = {
  icon: typeof Home;
  labelKey: string;
  path: string;
  /** Plan badge shown until the master is on the tier that unlocks it. */
  badge?: string;
};

/** Master sidebar, in display order. */
export const SIDEBAR_LINKS: NavItem[] = [
  { icon: Home, labelKey: 'nav.home', path: ROUTES.app.root },
  { icon: Calendar, labelKey: 'nav.calendar', path: ROUTES.app.calendar },
  { icon: Layers, labelKey: 'nav.services', path: ROUTES.app.services },
  { icon: ImageIcon, labelKey: 'nav.portfolio', path: ROUTES.app.portfolio },
  { icon: Users, labelKey: 'nav.clients', path: ROUTES.app.clients },
  { icon: Users2, labelKey: 'nav.team', path: ROUTES.app.team, badge: 'Studio' },
  { icon: Star, labelKey: 'nav.reviews', path: ROUTES.app.reviews },
  { icon: BarChart3, labelKey: 'nav.analytics', path: ROUTES.app.analytics },
  { icon: Settings, labelKey: 'nav.settings', path: ROUTES.app.settings },
];

/** The four destinations on the master's mobile bottom bar. */
export const MOBILE_LINKS: NavItem[] = [
  { icon: Home, labelKey: 'nav.home', path: ROUTES.app.root },
  { icon: Calendar, labelKey: 'nav.calendar', path: ROUTES.app.calendar },
  { icon: Users, labelKey: 'nav.clients', path: ROUTES.app.clients },
  { icon: User, labelKey: 'nav.profile', path: ROUTES.app.settings },
];

/**
 * True when `path` is the section the current URL belongs to.
 *
 * The dashboard root is matched exactly; every other entry also owns its
 * sub-pages, so /app/settings/profile keeps Settings highlighted.
 */
export const isNavItemActive = (pathname: string, path: string) =>
  pathname === path || (path !== ROUTES.app.root && pathname.startsWith(path));
